// extracted by mini-css-extract-plugin
export var advbtn = "gallerylightbox-module--advbtn--be4c1";
export var artistDetailsStyle = "gallerylightbox-module--artistDetailsStyle--6a943";
export var artistHeadingStyle = "gallerylightbox-module--artistHeadingStyle--0fb2b";
export var border = "gallerylightbox-module--border--5539f";
export var closeButton = "gallerylightbox-module--closeButton--5b5aa";
export var container = "gallerylightbox-module--container--82df3";
export var heading = "gallerylightbox-module--heading--677e7";
export var iframe = "gallerylightbox-module--iframe--ef546";
export var imgContainerlightBox = "gallerylightbox-module--imgContainerlightBox--2dc34";
export var leftColumn = "gallerylightbox-module--leftColumn--7a406";
export var lightboxContent = "gallerylightbox-module--lightboxContent--bd68c";
export var lightboxOpen = "gallerylightbox-module--lightboxOpen--0b77f";
export var lightboxOverlay = "gallerylightbox-module--lightboxOverlay--304f3";
export var paragraph = "gallerylightbox-module--paragraph--0743a";
export var rightColumn = "gallerylightbox-module--rightColumn--858f4";
export var sectionMandatPad = "gallerylightbox-module--sectionMandatPad--28b21";
export var title = "gallerylightbox-module--title--82344";
export var tracked = "gallerylightbox-module--tracked--4bd58";
export var twoColumnLayout = "gallerylightbox-module--twoColumnLayout--21dde";